<template>
    <div>
        <label>White Label</label>
        <select v-model="valueCopy" class="form-control">
            <option :value="null">None - Use Default</option>
            <option v-for="wl in whiteLabels" :value="wl.whiteLabelId">
                {{wl.name}}
            </option>
        </select>
    </div>
</template>

<script>
    import {configTables} from "../../../../global/configTables.js";

    export default {
        name: "WhiteLabelDropDown",
        props: {
            value: {
                required: true, validator: function (val) {
                    return val == null || (typeof val === "number");
                }
            }
        },
        data() {
            return {
                valueCopy: this.value,
                whiteLabels: []
            };
        },
        watch: {
            value(originalUpdated) {
                this.valueCopy = originalUpdated;
            },
            valueCopy(selectedCoverage) {
                this.$emit('input', selectedCoverage);
            }
        },
        async mounted() {
            this.whiteLabels = await configTables.getWhiteLabelOptions();
        }
    }
</script>

<style scoped>

</style>